// Custom global scripts
jQuery(document).ready(function ($) {
    'use strict';

    if ($(".nav-tabs-toggle").length) {
        $(".nav-tabs-title").text($(".tabs-title.is-active a").text());
    }

    // nav tab toggle
    $('.nav-tabs-toggle').on('click', function () {
        $('.tabs').toggleClass("display-flex");
    });

    $('.tabs-title').on('click', function () {
        $(".nav-tabs-title").text($(this).children('a').text());
        $('.tabs').toggleClass("display-flex");
    });

}(jQuery));
